import React, { Component } from 'react';
import { motion } from 'framer-motion';
import { Brain, ClipboardList, Puzzle, MessageCircle, Heart, Sparkles } from 'lucide-react';
// 👉 EDITÁ EL CONTENIDO DE ESTA SECCIÓN ABAJO
export const modulesContent = {
  title: 'Qué incluye el MegaPack',
  subtitle: '6 tomos y 6 bonos clínicos especializados en neurodesarrollo infantil.',
  modules: [{
    icon: 'Brain',
    title: 'TOMO 1: Bases Clínicas del Neurodesarrollo Infantil',
    description: 'Fundamentos teóricos, plasticidad cerebral y áreas del desarrollo. Marco conceptual completo para tu práctica.'
  }, {
    icon: 'ClipboardList',
    title: 'TOMO 2: Evaluación y Observación en Estimulación Temprana',
    description: 'Herramientas clínicas para la detección, observación y seguimiento del desarrollo infantil.'
  }, {
    icon: 'Puzzle',
    title: 'TOMO 3: Integración Sensorial y Desarrollo Motor',
    description: 'Estrategias de intervención y actividades terapéuticas para trabajar lo sensorial y motor.'
  }, {
    icon: 'MessageCircle',
    title: 'TOMO 4: Lenguaje, Comunicación y Desarrollo Cognitivo',
    description: 'Herramientas de intervención para el desarrollo comunicativo y cognitivo en la primera infancia.'
  }, {
    icon: 'Heart',
    title: 'TOMO 5: Regulación Emocional y Conductual',
    description: 'Estrategias para acompañar emociones, conductas y vínculos en la primera infancia.'
  }, {
    icon: 'Sparkles',
    title: 'TOMO 6: Intervención Temprana en Desafíos del Neurodesarrollo',
    description: 'Abordaje interdisciplinario en TEA, TDAH y otros desafíos del desarrollo.'
  }]
};
const iconMap: Record<string, React.ElementType> = {
  Brain,
  ClipboardList,
  Puzzle,
  MessageCircle,
  Heart,
  Sparkles
};
export function Modules() {
  return <section className="py-24 px-4 bg-brand-dark" data-id="element-141">
      <div className="max-w-6xl mx-auto" data-id="element-142">
        <div className="text-center mb-16" data-id="element-143">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl md:text-5xl font-serif mb-4 text-brand-light" data-id="element-144">
            {modulesContent.title}
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-lg text-brand-light/70 font-sans" data-id="element-145">
            {modulesContent.subtitle}
          </motion.p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-146">
          {modulesContent.modules.map((mod, index) => {
          const IconComponent = iconMap[mod.icon] || Brain;
          return <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: index * 0.1
          }} className="bg-brand-card border border-brand-cardBorder rounded-2xl p-8 hover:border-brand-accent/50 transition-colors group" data-id="element-147">
                <div className="w-12 h-12 rounded-xl bg-brand-dark border border-brand-cardBorder flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300" data-id="element-148">
                  <IconComponent className="w-6 h-6 text-brand-accent" data-id="element-149" />
                </div>
                <h3 className="text-xl font-serif font-semibold mb-3 text-brand-light" data-id="element-150">
                  {mod.title}
                </h3>
                <p className="text-brand-light/70 font-sans text-sm leading-relaxed" data-id="element-151">
                  {mod.description}
                </p>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}